export default __webpack_public_path__ + "static/media/What-we-do-Landing page-Enterprise Software Development.c57f2f6b.png";